import React, { useState, createContext, useContext } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { AlertTriangle } from 'lucide-react';

const ConfirmContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return context;
};

export const ConfirmProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    title: 'Confirmar',
    message: 'Tem certeza?',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    onConfirm: () => {},
    variant: 'default'
  });

  const confirm = ({ title, message, confirmText, cancelText, variant }) => {
    return new Promise((resolve) => {
      setConfig({
        title: title || 'Confirmar',
        message: message || 'Tem certeza?',
        confirmText: confirmText || 'Confirmar',
        cancelText: cancelText || 'Cancelar',
        variant: variant || 'default',
        onConfirm: () => {
          setIsOpen(false);
          resolve(true);
        },
        onCancel: () => {
          setIsOpen(false);
          resolve(false);
        }
      });
      setIsOpen(true);
    });
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      
      <Dialog open={isOpen} onOpenChange={(open) => {
        if (!open) config.onCancel();
      }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {config.variant === 'destructive' && <AlertTriangle className="h-5 w-5 text-red-600" />}
              {config.title}
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-gray-600 whitespace-pre-line">{config.message}</p>
          <DialogFooter>
            <Button variant="outline" onClick={config.onCancel}>
              {config.cancelText}
            </Button>
            <Button 
              variant={config.variant} 
              onClick={config.onConfirm}
            >
              {config.confirmText}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </ConfirmContext.Provider>
  );
};
